import React from "react";
import {glavnoeLogoLight} from "./glavnoeLogoLight";
import {glavnoeLogoDark} from "./glavnoeLogoDark"
import {operativnoLogoLight} from "./operativnoLogoLight"
import {operativnoLogoDark} from "./operativnoLogoDark"

export const Logo = ({ showMainLogo, isDark }) => {
    if (showMainLogo) {
        return isDark ? glavnoeLogoDark() : glavnoeLogoLight()
    }else {
        return isDark ? operativnoLogoDark() : operativnoLogoLight()
    }
}
